import { render, staticRenderFns } from "./aitutor2.vue?vue&type=template&id=7ded7e76&"
import script from "./aitutor2.vue?vue&type=script&lang=js&"
export * from "./aitutor2.vue?vue&type=script&lang=js&"
import style0 from "./aitutor2.vue?vue&type=style&index=0&id=7ded7e76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports